<template>
	<div class="guide-container">
		<div class="guide-content">
			<ul class="guide-box">
				<li>
					<!-- <span class="s1"></span> -->
					<span class="icon">
						<svg-icon icon-class="selectionService"></svg-icon>
					</span>

					选择服务
					<span class="arrow"></span>
				</li>
				<li>
					<span class="icon">
						<svg-icon icon-class="order"></svg-icon>
					</span>
					下单支付
					<span class="arrow"></span>
				</li>
				<li>
					<span class="icon">
						<svg-icon icon-class="survey"></svg-icon>
					</span>
					开始服务
					<span class="arrow"></span>
				</li>
				<li>
					<span class="icon">
						<svg-icon icon-class="complete"></svg-icon>
					</span>
					完成服务
					<span class="arrow"></span>
				</li>
				<li>
					<span class="icon">
						<svg-icon icon-class="guidance"></svg-icon>
					</span>
					售后服务
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	// 底部服务流程向导
	export default {
		name: 'FooterGuide',
		components: {},
		props: {},
		data() {
			return {}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped>
	.guide-container {
		height: 100px;
		background-image: url('~@/assets/index/guide/bg.png');
		background-position: center;
		.guide-content {
			width: $main-page-width;
			margin: 0 auto;
			.guide-box {
				display: flex;
				justify-content: space-between;
				align-items: center;
				height: 100px;
				font-size: 18px;
				color: #ffffff;
				li {
					display: flex;
					align-items: center;
					position: relative;
					.icon {
						width: 44px;
						height: 44px;
						background-color: #ffffff;
						border-radius: 50%;
						display: block;
						margin-right: 17px;
						display: flex;
						align-items: center;
						justify-content: center;
					}

					.svg-icon {
						color: #3486ff;
						font-size: 35px;
					}
					.arrow {
						width: 38px;
						height: 11px;
						background: url('~@/assets/index/guide/jt.png') 50% 50% no-repeat;
						margin: 0px 70px;
					}
				}
			}
		}
	}
</style>
